import React, { useEffect, useRef } from 'react'

import PropTypes from 'prop-types'

import PerfectScrollbar from 'react-perfect-scrollbar'

import {
  SidePanelContainer,
  SidePanelHeaderContainer,
  SidePanelSeparator as SidePanelSeparatorImp
} from './SidePanel.styles'

export const SidePanel = ({
  className,
  children,
  header,
  footer,
  'data-mu-test': dataAttributeTest,
  show,
  top,
  width,
  onClickOutside,
  onContentScrollY
}) => {
  const containerEl = useRef(null)

  const handleClickOutside = event => {
    if (
      show &&
      containerEl &&
      containerEl.current &&
      !containerEl.current.contains(event.target) &&
      typeof onClickOutside === 'function'
    ) {
      onClickOutside(event)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [containerEl, show])

  const handleScrollY = container => {
    if (typeof onContentScrollY === 'function') {
      onContentScrollY(container.scrollTop)
    }
  }

  return (
    <SidePanelContainer
      ref={containerEl}
      className={className}
      data-mu-test={dataAttributeTest}
      show={show}
      top={top}
      width={width}
    >
      <PerfectScrollbar suppressScrollX onScrollY={handleScrollY}>
        {children}
      </PerfectScrollbar>
    </SidePanelContainer>
  )
}

SidePanel.defaultProps = {
  show: false,
  top: '0',
  width: '50vw'
}

SidePanel.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  header: PropTypes.node,
  footer: PropTypes.node,
  'data-mu-test': PropTypes.string,
  show: PropTypes.bool,
  top: PropTypes.string,
  width: PropTypes.string,
  onClickOutside: PropTypes.func,
  onContentScrollY: PropTypes.func
}

export const SidePanelHeader = SidePanelHeaderContainer

export const SidePanelSeparator = SidePanelSeparatorImp
